import httpClient from './client'

export default {
  // 直播间详情
  async getLiveDetail (id) {
    const url = `/room/${id}`
    const res = await httpClient.get(url)
    return res && res.data && res.data.data
  },
  async getLiveDetailV2 (id, tapeId = '') {
    const url = `/v2/room/${id}`
    const params = tapeId ? {showRoomSharePageConfig: 1, tapeId} : {showRoomSharePageConfig: 1}
    const res = await httpClient.get(url, {params})
    return res && res.data && res.data.data
  },
  // 评论列表
  async getChatMessageList (id, limit = 20) {
    const url = `/room/${id}/comments`
    const res = await httpClient.get(url, {
      params: {
        limit
      }
    })
    return res && res.data && res.data.data
  },
  async getAuthorInfo (userId) {
    const url = `/users/${userId}`
    const res = await httpClient.get(url)
    return res && res.data && res.data.data
  },
  async joinRoom (roomId) {
    const url = `/room/${roomId}/join`
    const res = await httpClient.put(url)
    return res && res.data && res.data.data
  },
  async leaveRoom (roomId) {
    const url = `/room/${roomId}/leave`
    const res = await httpClient.put(url)
    return res && res.data && res.data.data
  },
  async shareRoom (roomId) {
    const url = `/room/${roomId}/share`
    const res = await httpClient.post(url)
    return res && res.data && res.data.data
  },
  async getRecommendRoom (roomId) {
    // const url = `/room/${roomId}/recommend`
    const url = `/close/room/recommend`
    const res = await httpClient.get(url)
    return res && res.data && res.data.data
  },
  async getLiveRecommend () {
    const url = `/room/recommend`
    try {
      const res = await httpClient.get(url)
      return res.data.data
    } catch (e) {

    }
  },
  async getAuthorVideos (id) {
    const url = `/authors/${id}/videos`
    try {
      const res = await httpClient.get(url)
      return res.data.data
    } catch (e) {

    }
  },
  async getVideosDynamic (videoId, limit = 10) {
    const url = `/videos/dynamic`
    try {
      const res = await httpClient.get(url, { params: { videoId, limit } })
      return res.data.data
    } catch (e) {

    }
  },
  async getHotVideo () {
    const url = `/categories/0/videos`
    try {
      const res = await httpClient.get(url)
      return res.data.data
    } catch (e) {

    }
  },
  async authorRealName (userId) {
    const url = `/author/${userId}/identity/realname`
    try {
      const res = await httpClient.get(url)
      return res.data.data
    } catch (e) {

    }
  },
  async shareRecord (data) {
    const url = `/shareRecord`
    try {
      const res = await httpClient.post(url, data)
      return res.data.data
    } catch (e) {

    }
  },
  async h5Guide (authorUid) {
    const url = `/author/config/h5Guide/${authorUid}`
    try {
      const res = await httpClient.get(url)
      return res.data.data
    } catch (e) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/live.js